/**
 * The naming split's parts (TMMAPP-0163 item 5): each non-zero count of `naming-status.bySource`,
 * in the free-first order (your rules, known merchants, the bank text, AI, then unnamed), then the
 * texts kept unnamed as their own part (TMMAPP-0164 item 12).
 */
import { NAMING_SOURCES } from '@/api/namingSource';
import type { PayeeNamingBySource } from '@/api/payeeSuggestions';

export type SplitKey = keyof PayeeNamingBySource;

export const SPLIT_ORDER: readonly SplitKey[] = [...NAMING_SOURCES, 'UNNAMED', 'KEPT_UNNAMED'];

export function splitParts(bySource: PayeeNamingBySource): { key: SplitKey; count: number }[] {
  return SPLIT_ORDER.flatMap((key) => (bySource[key] > 0 ? [{ key, count: bySource[key] }] : []));
}
